<app-nav></app-nav>
<section [ngStyle]="{'background-image': getUrl(),'background-size': 'cover'}">
  <div class="fix-width">
  <div class="text-center">
  <h5 [ngStyle]="{'padding-top': '10px', 'font-weight':'500'}">Select Insurer/TPA to view their Network Hospital List</h5>
    
  </div>
  <ng-container *ngIf="!isClinetNFI">
  <div class="logoContainer">
  <div id="productSlider" class="carousel slide" data-ride="carousel" data-interval="false">
    <p class="select-insurer">Select Insurer</p>
    <div class="carousel-inner">
      <div class="carousel-item active">
        <div class='row' >
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="care" 
                     name="hospitalLogo" 
                     (change)="selectInsurer($event)"/>
              <label for="care" class='mar-20p'>
                <img src="assets/images/hospital_logos/care.png"/>
              </label>
            </span>
          </div>
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="star" 
                     name="hospitalLogo" 
                     (change)="selectInsurer($event)"/>
              <label for="star" class='mar-20p'>
                <img src="assets/images/hospital_logos/star.png"/>
              </label>
            </span>
          </div>
        </div>

        <div class='row'>
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="icici" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="icici" class='mar-20p'>
                <img src="assets/images/hospital_logos/icici_logo.png" class="max-width-image"/>
              </label>
            </span>
          </div>
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="bajaj" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="bajaj" class='mar-20p'>
                <img src="assets/images/hospital_logos/bajaj.png" class="max-width-image"/>
              </label>
            </span>
          </div>
        </div>

        <div class='row'>
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="adityaBirla" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="adityaBirla" class='mar-20p'>
                <img src="assets/images/hospital_logos/aditya_birla.png" class="max-width-image"/>
              </label>
            </span>
          </div>
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="reliance" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="reliance" class='mar-20p'>
                <img src="assets/images/hospital_logos/Induslnd_General_Insurance.png" class="max-width-image"/>
              </label>
            </span>
          </div>
        </div>

        <div class='row'>
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="royalSundaram" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="royalSundaram" class='mar-20p'>
                <img src="assets/images/hospital_logos/RoyalSundaramGIlogo.png" class="max-width-image"/>
              </label>
            </span>
          </div>
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="Max_health" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="Max_health" class='mar-20p'>
                <img src="assets/images/hospital_logos/NivaLogo.png" class="max-width-image"/>
              </label>
            </span>
          </div>
        </div>
    
      </div>
      
      <div class="carousel-item">
        <div class='row'>
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="Unitedhealth" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="Unitedhealth" class='mar-20p'>
                <img src="assets/images/hospital_logos/Unitedhealth.png" class="max-width-image"/>
              </label>
            </span>
          </div>
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="Medi_assist" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="Medi_assist" class='mar-20p'>
                <img src="assets/images/hospital_logos/Medi_assist.png" class="max-width-image"/>
              </label>
            </span>
          </div>
          <!-- <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="vipul" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="vipul" class='mar-20p'>
                <img src="assets/images/hospital_logos/vipul.png" class="max-width-image"/>
              </label>
            </span>
          </div> -->
        </div>

        <div class='row'>
          <!-- <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="Medi_assist" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="Medi_assist" class='mar-20p'>
                <img src="assets/images/hospital_logos/Medi_assist.png" class="max-width-image"/>
              </label>
            </span>
          </div> -->
          <!-- <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="alankit" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="alankit" class='mar-20p'>
                <img src="assets/images/hospital_logos/alankit.png"/>
              </label>
            </span>
          </div> -->
        </div>

        <div class='row'>
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="raksha" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="raksha" class='mar-20p'>
                <img src="assets/images/hospital_logos/raksha.png"/>
              </label>
            </span>
          </div>
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="FHPL" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="FHPL" class='mar-20p'>
                <img src="assets/images/hospital_logos/fhpl-logo_footer.png"/>
              </label>
            </span>
          </div>
        </div>

        <div class='row'>
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="Hdfc" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="Hdfc" class='mar-20p'>
                <img src="assets/images/hospital_logos/Hdfc.png"/>
              </label>
            </span>
          </div>
          
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="Paramount_Newlogo" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="Paramount_Newlogo" class='mar-20p'>
                <img src="assets/images/hospital_logos/Paramount_Newlogo.png"/>
              </label>
            </span>
          </div>
        </div>
    
      </div>

      <div class="carousel-item">
        <div class='row'>
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="healthIndia" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="healthIndia" class='mar-20p'>
                <img src="assets/images/hospital_logos/healthIndia.png" class="max-width-image"/>
              </label>
            </span>
          </div>

          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="vidalHealth" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="vidalHealth" class='mar-20p'>
                <img src="assets/images/hospital_logos/vidalHealth.png" class="max-width-image"class="max-width-image"/>
              </label>
            </span>
          </div>
          
        </div>

        <div class='row'>
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="medsave" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="medsave" class='mar-20p'>
                <img src="assets/images/hospital_logos/medsave.png"/>
              </label>
            </span>
          </div>
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="park" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="park" class='mar-20p'>
                <img src="assets/images/hospital_logos/park.png"/>
              </label>
            </span>
          </div> 
        </div>

        <div class='row'>
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="VisionTpa" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="VisionTpa" class='mar-20p'>
                <img src="assets/images/hospital_logos/VisionTpa.png"/>
              </label>
            </span>
          </div>
           
          <div class="col-6 mt-3">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="iffcoTokio" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="iffcoTokio" class='mar-20p'>
                <img src="assets/images/hospital_logos/iffcoTokioInsurer.png"/>
              </label>
            </span>
          </div>
        </div>

        <div class='row'>
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="digit" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="digit" class='mar-20p' style="margin-left:15px!important">
                <img src="assets/images/hospital_logos/digit.png"/>
              </label>
            </span>
          </div>
           
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="manipal" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="manipal" class='mar-20p'>
                <img src="assets/images/hospital_logos/manipal.png" width="70%!important"/>
              </label>
            </span>
          </div>
        </div>
      </div>

      <div class="carousel-item">
        <div class='row'>
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="future" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="future" class='mar-20p'>
                <img src="assets/images/hospital_logos/fglogo.png" class="max-width-image"/>
              </label>
            </span>
          </div>
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                autocomplete='off'
                   id="geniss" 
                   name="hospitalLogo"
                   (change)="selectInsurer($event)" />
            <label for="geniss" class='mar-20p'>
              <img src="assets/images/hospital_logos/geniss.png" style="width: 200px!important"/>
            </label>
            </span>
          </div>
        </div>
        <div class='row'>
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="sbi" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="sbi" class='mar-20p'>
                <img src="assets/images/hospital_logos/sbiLogo.svg" class="max-width-image"/>
              </label>
            </span>
          </div>
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="tataLogo" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="tataLogo" class='mar-20p'>
                <img src="assets/images/hospital_logos/tataAig.png" class="max-width-image"style="height:75px" />
              </label>
            </span>
          </div>
        </div>
        <div class='row'>
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="cholo" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="cholo" class='mar-20p'>
                <img src="assets/images/hospital_logos/chola_logo.png" class="max-width-image"/>
              </label>
            </span>
          </div>
          <div class="col-6">
            <span class="image-container">
              <input type="radio" 
                  autocomplete='off'
                     id="mdIndia" 
                     name="hospitalLogo"
                     (change)="selectInsurer($event)" />
              <label for="mdIndia" class='mar-20p'>
                <img src="assets/images/hospital_logos/mdIndia.png" style="width: 120px; height: 75px;"/>
              </label>
            </span>
          </div>
        </div>
     </div>

  </div>
  </div>
  
</div>
</ng-container>

<!-- For NFI client only -->
<ng-container *ngIf="isClinetNFI">
  <div class="logoContainer">
    <div id="productSlider" class="carousel slide" data-ride="carousel" data-interval="false">
       <p class="select-insurer">Select Insurer</p>
          <div class="carousel-inner">
             <div class="carousel-item  active">
                <div class='row'>
                   <div class="col-6">
                      <span class="image-container">
                      <input type="radio" 
                         autocomplete='off'
                         id="Paramount_Newlogo" 
                         name="hospitalLogo"
                         (change)="selectInsurer($event)" />
                      <label for="Paramount_Newlogo" class='mar-20p'>
                      <img src="assets/images/hospital_logos/Paramount_Newlogo.png"/>
                      </label>
                      </span>
                   </div>
                </div>
             </div>
          </div>
    </div>
 </div>
</ng-container>

<div class="row mg-top-30 text-right">
  <div class="col-12">
    <img src="assets/images/hospital_logos/down-arrow.png" (click)="dataToSlidefunc()" data-target="#productSlider" attr.data-slide-to={{dataToSlide}}>
  </div>
</div>

  <div class="row text-center" style="margin-top:5px">
    <div class="col">
      <button [disabled]="isDisabled" class="btn btn-submit btn-primary" type="submit" (click)="navigateToInsurer()">View Hospital List</button>
    </div>
</div>
<!-- <div class='row top-gap-lg'>
  <div class='col-5'><hr/></div>
  <div class='col-2'><div class="text-center">OR</div></div>
  <div class='col-5'><hr/></div>
</div> -->
</div>
  <!-- <section class="hospital-panel mg-top-30">
    <div class="container hl-wrap">
      <div class="text-center">
        <h1 style="font-size:2rem">Hospital Locator</h1>
        <p style="margin-bottom:30px;">Search for over 10,000 hospitals, intelligently. Filter by insurer, panels and
          specialty. Locate on a map</p>
      </div>
      <div>
        <form #hlForm="ngForm" (ngSubmit)="hospitalData()">
          <input type="text" class="input-texts" name="name" #hData [(ngModel)]="searchFilter"
            placeholder="Enter Hospital , Insurance or Location" ngModel required>
          <button type="submit" value="submit" class="hl-btn" (click)="submitForm()">Search
          </button>
        </form>
      </div>
    </div>
  </section> -->
  <!-- <div class="container" *ngIf="hospitalSecondFold">
    <div class="hl-filter-wrap d-flex">
      <form class="hl-search">
        <input type="text" name="search" [(ngModel)]="searchText" autocomplete="off" placeholder="Search hospital">
        <button type="submit" value="submit">
          <img src="../../assets/images/search-icon.svg" width="17px;">
        </button>
      </form>
      <button (click)="openFilterModal()" type="submit" class="hl-filter">
        <span><img src="../assets/images/filter-results-button.svg"></span>
        Filter
      </button>
      <button (click)="openSortingModal()" type="submit" class="hl-sort"><span><img
            src="../assets/images/sort-icon.svg"></span>Sort</button>
    </div>
    <div class="modal-container" *ngIf="modalFilterContainer">
      <div class="modal-overlay"></div>
      <div class="modal-card">
        <div class="modal-card-body" style="height:65vh;">
          <h4>Filter Options</h4>
          <form #filterForm="ngForm">
            <input type="text" class="city-search" name="search" [(ngModel)]="searchText" autocomplete="off"
              placeholder="Search city">
            <span>
              <button type="submit" class="btn-blue" (click)="getCityList()">Select City</button>
              <ul class="location-filter" *ngIf="cityData">
                <li *ngFor="let city of cityList let i = index;">
                  {{city}}<input [ngValue]="city" (change)="onCheckCityList($event)" type="checkbox" name="city{{i}}">
                </li>
              </ul>
            </span>
            <span>
              <button type="submit" class="btn-blue" (click)="getInsurer()">Insurer</button>
              <ul class="location-filter" *ngIf="showInsurer">
                <li *ngFor="let insurer of insurerName | filter:searchText">
                  {{insurer}}<input [ngValue]="insurer" type="checkbox" (change)="onCheckInsurerName($event)"
                    name="selectInsurer{{i}}">
                </li>
              </ul>
            </span>
          </form>
        </div>
        <span class="modal-btn-wrap">
          <button (click)="hospitalData()">Apply</button>
          <button (click)="closeModal()">Cancel</button>
        </span>
      </div>
    </div>

    <div class="hl-show-cards" *ngIf="users">
      <ng-container *ngIf="!moreHospitalData">
        <div ng-click='sortColumn("sno")' class="hl-card" *ngFor="let user of users.data | filter:searchText">
          <div class="hl-card-content">
            <p>Hospital Name:<span>{{user.hospitalName}}</span></p>
            <p>Hospital Address:<span>{{user.hospitalAddress}}</span></p>
            <p>Linked Insurance: <span class="tags">{{user.source}}</span></p>
            <p>View Map
              <button class="hl-map">
                <a href="https://www.google.com/maps/search/?api=1&query={{user.hospitalName}}"><img
                  src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/sign-up/icons/hospital-locator.svg"
                  alt="map-icon"></a>
              </button>
            </p>
            <div class="modal-container" *ngIf="modalMapContent">
              <div class="modal-overlay" style="opacity:0.6;"></div>
              <div class="modal-card" style="top:0;">
                <div class="modal-card-body">
                  <iframe src="https://www.google.com/maps/embed?secureNow" width="300" height="450" frameborder="0"
                    style="border:0;" allowfullscreen=""></iframe>
                </div>
                <span class="close-map-modal">
                  <button (click)="closeModal()">&times;</button>
                </span>
              </div>
            </div>
          </div>
          <button class="hl-more-data" (click)="viewMoreData(user)">View More</button>
        </div>
      </ng-container>
      <div class="modal-container-vm ng-cloak" *ngIf="moreHospitalData">
        <div class="modal-overlay-vm"></div>
        <div class="modal-card-vm">
          <p><strong>{{selectedDataUser.hospitalName}}</strong></p>
          <p>Brief Description</p>
          <p>Address:<span>{{selectedDataUser.hospitalAddress}}</span></p>
          <p>Description:<span>{{selectedDataUser.hospitalDescription}}</span></p>
          <p>City Name:<span>{{selectedDataUser.cityName}}</span></p>
          <p>Phone Number:<span>{{selectedDataUser.contactNo}}</span></p>
          <p>Source Name:<span class="tags">{{selectedDataUser.source}}</span></p>
          <p>Insurer Name:<span><strong>
                {{selectedDataUser.insurer}}
              </strong></span></p>
          <p>Speciality:<span>{{selectedDataUser.score}}</span></p>

        <p>Insurer<span class="tags">{{user.source}}</span></p> 
          <span class="back-prev">
            <button (click)="closeModal()">Back</button>
          </span>
        </div>
      </div>
    </div>
  </div> -->
</section>